/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable max-len */
import type { FC, MouseEvent, PropsWithChildren } from 'react';
import React, { useState } from 'react';
import cx from 'classnames';
import Link from 'next/link';

import styles from '../StaticContents.module.scss';

interface Anchor {
	className: string;
	href: string;
}

interface OpenState {
	[links: string]: boolean;
}

const Privacy = () => {
	const links = ['privacy-section-one', 'privacy-section-two', 'privacy-section-three', 'privacy-section-four'];
	const defaultState = links.reduce((acc, link) => ({ ...acc, [link]: false }), {});
	const [openState, setOpenState] = useState<OpenState>(defaultState);

	const onClick = (e: MouseEvent<HTMLAnchorElement>) => {
		e.preventDefault();

		const id = String(e.currentTarget?.getAttribute('href')?.substr(1));

		setOpenState((prevState) => ({
			...prevState,
			[id]: true,
		}));
	};

	const A: FC<PropsWithChildren<Anchor>> = (props: Anchor) => <a {...props} onClick={onClick} />;

	return (
		<div className={cx(styles.staticContents, styles.container)}>
			<h1>Dealer Privacy Policy</h1>
			<div>
				<div>
					<p>
						This Privacy Policy was last updated on 1 May 2025. Motorway Online Ltd is the owner and operator of a used
						car marketplace.
					</p>
					<p>
						Save for where specified otherwise, capitalised terms on this page shall bear the same meanings as those
						given to them in our{' '}
						<Link className="mw-link" href="/terms">
							Motorway Pro Terms
						</Link>
						.
					</p>
					<p>
						In order to provide you with access to the Motorway Platform and the other Motorway Products, we require
						certain information from you. This policy details the types of personal information we collect and process
						about you, what we use it for, and how we will treat it. Please read this policy carefully and contact us if
						you have any questions as set out below.
					</p>
					<h3>Information we process about you</h3>
					<p>When you use the Motorway Platform, we will collect certain information about you, such as:</p>
					<ul data-indent>
						<li>basic contact information you provide to us;</li>
						<li>transaction and payment information;</li>
						<li>delivery details (e.g., where you elect to use Motorway Move);</li>
						<li>records of how you access and use the Motorway Platform;</li>
						<li>
							identity documentation and information required for onboarding to third party services or products (e.g.
							Motorway Protect and Motorway Pay);
						</li>
						<li>
							information we obtain from public sources (e.g., for the purposes of carrying out anti-money laundering
							and know-your-client checks);
						</li>
						<li>
							information we receive from third parties (e.g., business partners, service providers, advertising
							networks, analytics providers, automotive data providers, search information providers or social networks,
							third party databases);
						</li>
						<li>records of communications you have with us;</li>
						<li>
							other information you and your staff provide to us voluntarily, including as part of a survey or
							promotion, or in order to attend events organised by us; and
						</li>
						<li>
							technical information about your device and website usage, including cookies (see our{' '}
							<Link className="mw-link" href="/cookies">
								Cookies Policy
							</Link>
							).
						</li>
					</ul>
					<p>
						<A className={cx('mw-link', { [styles.moreHidden]: openState[links[0]] })} href="#privacy-section-one">
							Find out more…
						</A>
					</p>
					<div className={cx(styles.hiddenSection, { [styles.section]: openState[links[0]] })} id="privacy-section-one">
						<h4>
							<u>Basic contact information you provide to us</u>
						</h4>
						<p>
							When you sign up to use the Motorway Platform, we will collect your name, post code, email address,
							telephone number and the company you work for. Amongst other things, we will use this information to
							contact you in respect of any Bids you make and, otherwise, to generally manage the sales process.
						</p>
						<h4>
							<u>Transaction and payments information</u>
						</h4>
						<p>
							When you sign up to use the Motorway Platform, and again whenever you purchase a Vehicle, we (or our third
							party payments provider) will collect bank and/or Modulr account details from you to enable us to both
							send and receive payments to or from you for our services. We will also keep a record of any purchases you
							make through the Motorway Platform and your method of purchase.
						</p>
						<h4>
							<u>Delivery details</u>
						</h4>
						<p>
							If you elect to use Motorway Move in order to have a Vehicle collected and dropped off, we will use your
							contact details and delivery preferences to facilitate this with our delivery partners.
						</p>
						<h4>
							<u>Records of how you use the Motorway Platform</u>
						</h4>
						<p>This may include details of your use of our Website, and records of any Vehicle purchases you make.</p>
						<h4>
							<u>Information we obtain from public sources</u>
						</h4>
						<p>
							As part of our onboarding process, and sometimes as part of audits or checks, we may obtain information
							about you and your business from third parties, such as Companies House.
						</p>
						<h4>
							<u>Information we obtain from third parties</u>
						</h4>
						<p>
							We may also work with third parties (including, for example, business partners, service providers,
							advertising networks, analytics providers, automotive data providers, reference agencies, PEP and sanction
							check providers, search information providers or social networks) and may receive information about you
							from them to make sure that the Motorway Platform is as effective and secure as possible.
						</p>
						<h4>
							<u>Records of communications you have with us</u>
						</h4>
						<p>
							If you contact us with a question or query or to provide us with feedback, for instance, we will keep a
							record of your communications with us.
						</p>
						<h4>
							<u>
								Other information you provide to us voluntarily, including as part of a survey or promotion, or in order
								to attend an event organised by us
							</u>
						</h4>
						<p>
							This may include data that you provide to us on our Website, to your account manager, or the details of
							any feedback that you provide to one of our online surveys or focus groups.
						</p>
						<p>
							In order to attend events organised by us, you may share with us your contact details as well as further
							information, such as dietary and access requirements.
						</p>
						<h4>
							<u>Technical information about your device and website usage</u>
						</h4>
						<p>When you use our Website, we collect certain technical information including:</p>
						<ul data-indent>
							<li>
								details about your device, such as your IP address, device type, operating system and browser; and
							</li>
							<li>
								information relating to use of the Website, such as the pages you visit and elements of the page you
								interact with.
							</li>
						</ul>
					</div>

					<h3>How we use your personal information</h3>
					<p>
						We use personal information about you for various purposes connected with your use of the Motorway Platform
						and Motorway Platform, including:
					</p>
					<ul data-indent>
						<li>
							to facilitate your use of the Motorway Platform in accordance with our{' '}
							<Link className="mw-link" href="/terms">
								Motorway Pro Terms
							</Link>
							, which includes sharing your information with Sellers if you have placed a Bid;
						</li>
						<li>
							to communicate with you in relation to your use of our services and provide you with customer support;
						</li>
						<li>for internal management, administrative and organisational reasons;</li>
						<li>
							to share information with our suppliers, transport partners and their drivers, and other third parties in
							order to provide you with our services;
						</li>
						<li>
							to send you offers, promotions or other marketing and/or information which we think you may find useful;
							and
						</li>
						<li>to develop and improve our business, through the use of data analytics and benchmarking.</li>
					</ul>
					<p>
						In order to use your personal information, we must have a legal basis for doing so. The legal bases that we
						rely upon are explained further in the “find out more” section below. We will only use your personal
						information where it is necessary:
					</p>
					<ul data-indent>
						<li>to fulfil our contract for services with you;</li>
						<li>to comply with a legal obligation to which we are subject; and/or</li>
						<li>
							for our legitimate business interests that are not overridden by your interests, rights and freedoms.
						</li>
					</ul>
					<p>
						Where none of the above applies, we will request your consent (which we will ask for before we process the
						information).
					</p>

					<p>
						<A className={cx('mw-link', { [styles.moreHidden]: openState[links[1]] })} href="#privacy-section-two">
							Find out more…
						</A>
					</p>
					<div className={cx(styles.hiddenSection, { [styles.section]: openState[links[1]] })} id="privacy-section-two">
						<p>
							The table below sets out further information about the purposes for which we use information about you,
							with the corresponding methods of collection and legal basis that we rely upon for its use.
						</p>
						<div className={styles.tableHorizontalScroll}>
							<table className={styles.table}>
								<thead>
									<tr>
										<td>Purpose</td>
										<td>Method of collection and legal basis for processing</td>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>
											<p>
												<strong>
													In order to provide you with the services you have requested, we need to collect and share
													your information in the following ways:
												</strong>
											</p>
											<ul data-indent>
												<li>in order to provide Sellers with your Bids and generally manage the sale process;</li>
												<li>
													to connect you with Sellers to enable you (or the transport provider) to inspect and purchase
													the Vehicle and generally manage the sales process;
												</li>
												<li>where applicable, to our Motorway Protect partners, to onboard you to that service; </li>
												<li>
													where applicable, to our Motorway Pay partners, to onboard and provide you with Motorway Pay
													services;
												</li>
												<li>
													where applicable, to provide our transport partners with your information in order to provide
													you with the Transport Services;
												</li>
											</ul>
										</td>
										<td>
											<strong>Method of collection</strong>
											<p>
												This information will be provided by you directly when you first sign up for the Motorway
												Platform and set up an account with us and then during the course of using our services.
											</p>
											<p>
												<strong>Legal basis</strong>
											</p>
											<p>
												Necessary for the performance of the contract between you and us in relation to the services. In
												all other cases, it is our legitimate business interest to provide efficient price comparison
												services.
											</p>
										</td>
									</tr>
									<tr>
										<td>
											<strong>To communicate with you, including via email, telephone, SMS and WhatsApp:</strong>
											<ul data-indent>
												<li>
													we will provide you with customer support and answers (including to assist you with the sales
													process) and/or respond to any queries or feedback that you send to us;
												</li>
												<li>
													to assist you with any technical problems you have with the Motorway Platform or Website;
												</li>
												<li>to collect reviews of our services in order to improve our business;</li>
												<li>to update you with any changes to our terms and conditions/other policies.</li>
											</ul>
										</td>
										<td>
											<strong>Method of collection</strong>
											<p>
												This information is collected any time when we communicate with you or you communicate with us.
											</p>
											<p>
												<strong>Legal basis</strong>
											</p>
											<p>
												It is our legitimate business interest to inform you of relevant information in relation to the
												services that we provide, respond to your communications and to improve our business.
											</p>
										</td>
									</tr>
									<tr>
										<td>
											<p>
												<strong>Internal management, administrative and organisational reasons</strong>
											</p>
											<ul data-indent>
												<li>to manage our Website and the Motorway Platform;</li>
												<li>
													to administer and manage our services and business in an efficient and proper way (e.g.,
													accounting, billing, etc.);
												</li>
												<li>to manage how we work with other companies that provide services to us;</li>
												<li>to carry out know-your-client checks;</li>
												<li>
													to establish and protect our business and legal rights or to defend ourselves against any
													legal actions;and
												</li>
												<li>to comply with legal requirements and obligations to which we are subject.</li>
											</ul>
										</td>
										<td>
											<strong>Method of collection</strong>
											<p>
												This information is collected from you both directly and indirectly, through Companies House and
												reference companies.
											</p>
											<p>
												<strong>Legal basis</strong>
											</p>
											<p>
												It is our legitimate business interest to manage and administer our services, the Motorway
												Platform, and Website, comply with laws to which we are subject and protect our business
												interests and legal rights.
											</p>
										</td>
									</tr>
									<tr>
										<td>
											<strong>To share information with service providers</strong>
											<ul data-indent>
												<li>
													See the section{' '}
													<u>
														<i>Who do we share your information with, and for what purposes?</i>
													</u>
													for more detail.
												</li>
											</ul>
										</td>
										<td>
											<strong>Method of collection</strong>
											<p>
												This may include any of the information we hold about you, whether collected by direct or
												indirect means.
											</p>
											<p>
												<strong>Legal basis</strong>
											</p>
											<p>
												It is our legitimate business interest to share your information with trusted third parties who
												provide us with services relevant to our provision of our services to you, including data
												storage providers, transport and insurance providers, content and data providers and customer
												management and support providers.
											</p>
										</td>
									</tr>
									<tr>
										<td>
											<strong>To send you offers, promotions or other marketing</strong>
											<ul data-indent>
												<li>
													To send you promotions, offers and bonuses that you may be interested in via email, text or
													post in accordance with your specific preferences (if applicable).
												</li>
											</ul>
										</td>
										<td>
											<strong>Method of collection</strong>
											<p>
												Your contact details will be collected when you sign up for the Motorway Platform and may be
												updated (along with your preferences) from time to time.
											</p>
											<p>
												<strong>Legal basis</strong>
											</p>
											<p>
												It is our legitimate business interest to send you marketing and promotional materials from time
												to time.
											</p>
											<p>
												If we send you a marketing email, it will include details on how to unsubscribe from receiving
												similar marketing messages in the future.
											</p>
										</td>
									</tr>
									<tr>
										<td>
											<strong>To improve and develop our services, the Motorway Platform, and Website</strong>
											<ul data-indent>
												<li>
													we conduct data analytics and benchmarking in order to understand, for example, the best
													performing Dealers and the most relevant Dealer for given Vehicles. This enables us to improve
													our services and offer the best and most relevant offers to our Dealers and Sellers alike;
												</li>
												<li>
													we conduct data analytics and benchmarking to understand how our Website and services are
													used, for example, which pages are visited and which elements of the page are interacted with.
													This enables us to improve our Website and services; and
												</li>
												<li>
													we conduct data analytics on the Seller Vehicle Data we collect, for example to understand the
													most popular makes, models or fuel types of vehicle and their values. This enables us to
													release information into the public realm about trends and changes in car ownership.
												</li>
											</ul>
										</td>
										<td>
											<strong>Method of collection</strong>
											<p>
												This information is collected across your interactions with the Website and your use of our
												services.
											</p>
											<p>
												<strong>Legal basis</strong>
											</p>
											<p>
												It is our legitimate business interest to identify ways to develop and improve our services,
												Website and business.
											</p>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>

					<h3>Who do we share your information with, and for what purposes?</h3>
					<p>We may share your personal information with:</p>
					<ul data-indent>
						<li>a Seller of a Vehicle if you have placed a Bid for that Vehicle;</li>
						<li>
							service providers, such as our transport partners and their drivers, payments processing providers,
							stocking finance partners, insurance providers, data analytics and technical support providers, data
							storage providers, content and data providers and customer management and support providers (including our
							outsourced customer service centre);
						</li>
						<li>
							law enforcement agencies or authorities where we believe this is necessary for the prevention, detection
							or enforcement of a crime; and
						</li>
						<li>our professional advisers and investors.</li>
					</ul>

					<p>
						<A className={cx('mw-link', { [styles.moreHidden]: openState[links[2]] })} href="#privacy-section-three">
							Find out more…
						</A>
					</p>
					<div
						className={cx(styles.hiddenSection, { [styles.section]: openState[links[2]] })}
						id="privacy-section-three"
					>
						<h4>
							<u>Seller of a Vehicle</u>
						</h4>
						<p>
							When you place a Bid for a Vehicle, we share information about you (such as name, postcode, email address,
							telephone number and the company you work for) with the Seller of a Vehicle in order to facilitate a sale.
							If you proceed with the purchase of a Vehicle, we will receive certain information about your transaction
							from the relevant Seller of the Vehicle, such as the date of collection and the final Purchase Price you
							paid, for billing and reporting purposes.
						</p>
						<h4>
							<u>Our Service Providers</u>
						</h4>
						<p>
							We use carefully selected service providers which process personal information about you on our behalf as
							described below:
						</p>
						<ul data-indent>
							<li>
								<strong>Transport partners:</strong> We use a network of trusted transport companies to provide you with
								Transport Services. They will receive the Seller Vehicle Data, along with details of the Seller, your
								delivery address, contact details, and preferred drop-off time.
							</li>
							<li>
								<strong>Payments:</strong> Where you are set up to make payments through the Motorway Platform, you will
								be required to provide certain personal information to our third-party payments processing provider,
								Modulr FS Limited (“Modulr”). Modulr will be required to process your personal information in order for
								them to provide a payment account and provide services under the{' '}
								<Link href="/payment-terms">Payment Terms</Link>. Modulr is a Data Controller and shall only use your
								personal data for this purpose. Modulr’s privacy policy is available{' '}
								<a href="https://www.modulrfinance.com/privacy-policy" rel="noopener noreferrer" target="_blank">
									here
								</a>
								.
							</li>
							<li>
								<strong>Insurance providers:</strong> To provide our Vehicle insurance services, like Motorway Protect,
								we partner with third party underwriters and claims management companies. In particular, These include
								Fortegra and Opteven.
							</li>
							<li>
								<strong>Data analytics and technical support providers:</strong> Such providers assist us in better
								understanding your use of our Website, the Motorway Platform, and our Services.
							</li>
							<li>
								<strong>Data storage providers:</strong> Such providers help operate the functionality of the Website
								and enable us to provide user accounts. They also provide backup, debugging and logging services.
							</li>
							<li>
								<strong>Content and data providers:</strong> Such providers assist us to, for example, verify your email
								address and telephone number, use your town/city to calculate routes between you and the Seller of a
								Vehicle, and use your postcode to geocode your approximate location.
							</li>
							<li>
								<strong>
									Customer management and support providers (including our outsourced customer service centre):
								</strong>{' '}
								Such providers deliver personalised email or SMS reminders to you in relation to your cars available for
								sale, and collect reviews of our services.
							</li>
						</ul>
						<section>
							<h4>Law Enforcement Agencies or Authorities</h4>
							<p>
								We may have to share your personal information with law enforcement agencies or authorities where we are
								required to comply with certain legal and regulatory requirements, and may process your personal
								information for compliance with such legal or regulatory obligation, to which we or regulators or law
								enforcement agencies are subject.
							</p>
							<p>
								This includes sharing your personal information where we believe this is necessary for the prevention,
								detection or enforcement of a crime (for example, if we believe that a transaction through our Website
								is fraudulent by using a stolen vehicle).
							</p>
						</section>
						<section>
							<h4>Our Professional Advisers and Investors</h4>
							<p>
								If required, we may share your personal information with professional advisers to obtain professional
								advice (for example, with a lawyer or insurer regarding a complaint, claim or potential claim relating
								to you).
							</p>
							<p>We may share your personal information if required as part of our obligations to our investors.</p>
							<p>
								We may also share your personal information with third parties in the event that we sell or buy any
								business or assets, in which case we may disclose your personal information to the prospective seller or
								buyer of such business or assets, along with its professional advisers.
							</p>
							<p>
								If you would like to receive a full list of our suppliers and other third parties who we share your
								information with then you can get in touch with us using the details provided in the section{' '}
								<Link className="mw-link" href="#contact-information">
									Contact Information
								</Link>
								.
							</p>
						</section>
						<h4>
							<u>Storage of your personal information</u>
						</h4>
						<p>
							Information about you and your dealership may be transferred outside the UK to a country, territory or
							international organisation that may not have UK equivalent data protection standards.
						</p>
						<p>
							This may be when we transfer your personal information to our trusted third party service providers (for
							the purposes described above) outside of the European Union. In such cases, we will ensure that your
							personal information is protected by implementing appropriate safeguards. If you would like more
							information about any of the transfer safeguards on which we rely please contact us as set out in this
							privacy policy.
						</p>
						<h4>How do we protect your personal information?</h4>
						<p>
							We implement appropriate technical and organisational measures to protect personal information that we
							hold from unauthorised disclosure, use, alteration or destruction. Where appropriate, we use encryption
							and other technologies that can assist in securing the information you provide. We also require our
							service providers to comply with strict data privacy requirements.
						</p>
						<h4>How long will your personal information be kept?</h4>
						<p>
							The period for which we may retain information about you will depend on the purposes for which the
							information was collected, whether you have requested the deletion of the information, and whether any
							legal obligations require the retention of certain information (for example, for regulatory compliance).
							We will not retain information about you for longer than is necessary to fulfil the purposes for which it
							was collected.
						</p>
					</div>
					<section id="third-party-links">
						<h3>Third party links</h3>
						<p>
							The Website may include links to third-party websites, plug-ins and applications. Clicking on those links
							or enabling those connections may allow third parties to collect or share data about you. We do not
							control these third-party websites and are not responsible for their privacy policies. When you leave our
							Website, we encourage you to read the privacy policy of the websites that you visit.
						</p>
					</section>
					<h3>Your rights as an individual</h3>
					<p>
						You as an individual* may have some or all of the following rights in respect of the information about you
						that we process:
					</p>
					<ul data-indent>
						<li>request us to give you access to it;</li>
						<li>request us to rectify it, update it, or erase it;</li>
						<li>request us to restrict our using it, in certain circumstances;</li>
						<li>object to our using it, in certain circumstances;</li>
						<li>withdraw your consent to our using it (where we have initially relied on consent)</li>
						<li>data portability, in certain circumstances;</li>
						<li>the right to opt out from our using it for direct marketing; and</li>
						<li>
							the right to lodge a complaint with the Information Commissioner’s Office, which is responsible for
							upholding your data protection rights in the UK.
						</li>
					</ul>
					<p>
						*Please note that these rights only relate to your personal information as an individual, and are not rights
						in respect of a company (i.e. your dealership).
					</p>
					<p>
						You are able to exercise these rights by contacting us, using the details set out in the section{' '}
						<Link className="mw-link" href="#contact-information">
							Contact Information
						</Link>
						.
					</p>

					<p>
						<A className={cx('mw-link', { [styles.moreHidden]: openState[links[3]] })} href="#privacy-section-four">
							Find out more…
						</A>
					</p>
					<div
						className={cx(styles.hiddenSection, { [styles.section]: openState[links[3]] })}
						id="privacy-section-four"
					>
						<p>You have the rights set out in the table below:</p>
						<div className={styles.tableHorizontalScroll}>
							<table className={styles.table}>
								<thead>
									<tr>
										<td>Right in respect of the information we hold about you</td>
										<td>Further detail (note: certain legal limits to all these rights apply)</td>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>
											<ul data-indent>
												<li>To request us to give you access to it.</li>
											</ul>
										</td>
										<td>
											This is confirmation of:
											<ul data-indent>
												<li>whether or not we process your personal information;</li>
												<li>our name and contact details;</li>
												<li>the purpose of the processing;</li>
												<li>the categories of information concerned;</li>
												<li>
													the categories of persons with whom we share the information and, where any person is outside
													the EU, the appropriate safeguards for protecting the information; and
												</li>
												<li>
													(if we have it) the source of the personal information, if we did not collect it from you;
												</li>
												<li>the criteria for determining the period for which we will store the information.</li>
												<p>On your request we will provide you with a copy of your personal information we hold.</p>
											</ul>
										</td>
									</tr>
									<tr>
										<td>
											<ul data-indent>
												<li>To request us to rectify or update it.</li>
											</ul>
										</td>
										<td>This applies if the information we hold is inaccurate or incomplete.</td>
									</tr>
									<tr>
										<td>
											<ul data-indent>
												<li>To request us to erase it.</li>
											</ul>
										</td>
										<td>
											This applies if:
											<ul data-indent>
												<li>
													the personal information we hold is no longer necessary in relation to the purposes for which
													we use it;
												</li>
												<li>
													we use the personal information on the basis of your consent and you withdraw your consent (in
													this case, we will remember not to contact you again, unless you tell us you want us to delete
													all information about you in which case we will respect your wishes);
												</li>
												<li>
													we use the personal information on the basis of legitimate interest and we find that,
													following your objection, we do not have an overriding interest in continuing to use it;
												</li>
												<li>the personal information was unlawfully obtained or used; or</li>
												<li>To comply with a legal obligation.</li>
											</ul>
										</td>
									</tr>
									<tr>
										<td>
											<ul data-indent>
												<li>To request us to restrict our processing of it.</li>
											</ul>
										</td>
										<td>
											This right applies, temporarily while we look into your case, if you:
											<ul data-indent>
												<li>contest the accuracy of the personal information we use; or</li>
												<li>have objected to our using the personal information on the basis of legitimate interest</li>
												(if you make use of your right in these cases, we will tell you before we use the personal
												information again).
											</ul>
											<p>This right applies also if:</p>
											<ul data-indent>
												<li>our use is unlawful and you oppose the erasure of the personal information; or</li>
												<li>
													we no longer need the personal information, but you require it to establish a legal case.
												</li>
											</ul>
										</td>
									</tr>
									<tr>
										<td>
											<ul data-indent>
												<li>To object to our processing it.</li>
											</ul>
										</td>
										<td>
											You have two rights here:
											<ul data-indent>
												<li>
													if we use your personal information for direct marketing: you can “opt out” (without the need
													to justify it) and we will comply with your request; and
												</li>
												<li>
													if we use your personal information on the basis of legitimate interest for purposes other
													than direct marketing, you can object to our using it for those purposes, giving an
													explanation of your particular situation, and we will consider your objection.
												</li>
											</ul>
										</td>
									</tr>
									<tr>
										<td>
											<ul data-indent>
												<li>To withdraw your consent to our using it.</li>
											</ul>
										</td>
										<td>
											<p>
												This right applies to any personal information which we have collected and processed based on
												your consent.
											</p>
											<p>You have the right at any time to withdraw the consent you have provided to us.</p>
										</td>
									</tr>
									<tr>
										<td>
											<ul data-indent>
												<li>To data portability.</li>
											</ul>
										</td>
										<td>
											This right applies:
											<ul data-indent>
												<li>To personal information that you have provided to us; and</li>
												<li>
													if we use that personal information on the basis either of your consent, or on the basis of
													discharging our contractual obligations to you.
												</li>
											</ul>
											<p>
												If both (i) and (ii) apply, you have the right to receive the information back from us in a
												commonly used format, and the right to require us to transmit the personal information to
												someone else if it is technically feasible.
											</p>
										</td>
									</tr>
									<tr>
										<td>
											<ul data-indent>
												<li>
													To lodge a complaint with the Information Commissioner’s Office or take your case to a
													national court.
												</li>
											</ul>
										</td>
										<td>
											<p>
												The UK’s supervisory authority responsible for upholding data protection rights is the{' '}
												<a href="https://ico.org.uk/" rel="noopener noreferrer" target="_blank">
													Information Commissioner’s Office
												</a>
												.
											</p>
											<p>You also have the right to obtain a remedy from a UK court.</p>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>

					<h3 id="contact-information">Contact information</h3>
					<p>
						For the purpose of UK data protection law, the controller is Motorway Online Ltd (Company Number 10285711)
						of 12-13 Wells Mews, London W1T 3HE.
					</p>
					<p>
						If you have any questions, or wish to exercise your rights, please contact us at any time on{' '}
						<Link className="mw-link" href="mailto:privacy@motorway.co.uk">
							privacy@motorway.co.uk
						</Link>{' '}
						or 020 3988 2288.
					</p>
				</div>
			</div>
		</div>
	);
};

export default Privacy;
